<template>
  <div>
    <div class="search_add2">
      <el-date-picker
        v-model="startTime"
        type="datetime"
        value-format="yyyyMMddHHmmss"
        format="yyyy/MM/dd HH:mm:ss"
        placeholder="选择日期"
      >
      </el-date-picker>
      <el-date-picker
        v-model="endTime"
        type="datetime"
        value-format="yyyyMMddHHmmss"
        format="yyyy/MM/dd HH:mm:ss"
        placeholder="选择日期"
      >
      </el-date-picker>
      <el-button type="primary" icon="el-icon-search" @click="search"
        >搜索</el-button
      >
    </div>

    <el-table
      :data="data"
      border
      stripe
      :height="tableHeight"
      style="width: 100%"
    >
      <af-table-column prop="id" label="设备编号"> </af-table-column>
      <af-table-column prop="msgType" label="报文类型"> </af-table-column>
      <af-table-column prop="ctime" label="采集时间"> </af-table-column>
      <af-table-column prop="rtime" label="上报时间"> </af-table-column>
      <af-table-column prop="temp" label="温度"> </af-table-column>
      <af-table-column prop="hum" label="湿度"> </af-table-column>
      <af-table-column prop="tempChanel1" label="温度通道1"> </af-table-column>
      <af-table-column prop="humidity1Range" label="湿度通道1">
      </af-table-column>
      <af-table-column prop="channel1" label="通道1离线/在线状态">
      </af-table-column>
      <af-table-column prop="tempChanel2" label="温度通道2"> </af-table-column>
      <af-table-column prop="humidity2Range" label="湿度通道2">
      </af-table-column>
      <af-table-column prop="channel2" label="通道2离线/在线状态">
      </af-table-column>
      <af-table-column prop="tempChanel3" label="温度通道3"> </af-table-column>
      <af-table-column prop="humidity3Range" label="湿度通道3">
      </af-table-column>
      <af-table-column prop="channel3" label="通道3离线/在线状态">
      </af-table-column>
      <af-table-column prop="tempChanel4" label="温度通道4"> </af-table-column>
      <af-table-column prop="humidity4Range" label="湿度通道4">
      </af-table-column>
      <af-table-column prop="channel4" label="通道4离线/在线状态">
      </af-table-column>
      <af-table-column prop="channel_status" label="离线/在线状态">
      </af-table-column>
      <af-table-column prop="doorOpenCount" label="开关门次数">
      </af-table-column>
      <af-table-column prop="gate1" label="门磁1"> </af-table-column>
      <af-table-column prop="gate2" label="门磁2"> </af-table-column>
      <af-table-column prop="wzttTemp" label="外置探头温度"> </af-table-column>
      <af-table-column prop="nzttTemp" label="内置探头温度"> </af-table-column>
      <af-table-column prop="positivPptoto" label="正面光敏"> </af-table-column>
      <af-table-column prop="reversePptoto" label="反面光敏"> </af-table-column>
      <af-table-column prop="open_box" label="开箱事件"> </af-table-column>
      <af-table-column prop="close_box" label="关箱事件"> </af-table-column>
      <af-table-column prop="speed" label="速度"> </af-table-column>
      <af-table-column prop="elev" label="海拔"> </af-table-column>
      <af-table-column prop="sateNum" label="卫星颗数"> </af-table-column>
      <af-table-column prop="locaStatus" label="定位状态"> </af-table-column>
      <af-table-column prop="elec" label="电量"> </af-table-column>
      <af-table-column prop="externalPower" label="外部供电标志">
      </af-table-column>
      <af-table-column prop="rssi" label="信号"> </af-table-column>
      <af-table-column prop="longitude" label="经度"> </af-table-column>
      <af-table-column prop="latitude" label="纬度"> </af-table-column>
      <af-table-column prop="gclLatitude" label="高德火星坐标系经度">
      </af-table-column>
      <af-table-column prop="gclLongitude" label="高德火星坐标系纬度">
      </af-table-column>
      <af-table-column prop="lbsLongitude" label="基站经度"> </af-table-column>
      <af-table-column prop="lbsLatitude" label="基站纬度"> </af-table-column>
      <af-table-column prop="lbsAddress" label="基站地址"> </af-table-column>
      <af-table-column prop="gpsAddress" label="经纬度地址"> </af-table-column>
      <af-table-column
      width="160"
        prop="direction"
        :label="'0度倾角参考安装图/1：垂直/ 2：侧面/3：水平'"
        :render-header="renderheader"
      >
      </af-table-column>
      <af-table-column prop="vibration" label="总震动"> </af-table-column>
      <af-table-column prop="vibrationX" label="X轴震动"> </af-table-column>
      <af-table-column prop="vibrationY" label="Y轴震动"> </af-table-column>
      <af-table-column prop="vibrationZ" label="Z轴震动"> </af-table-column>
      <af-table-column prop="tiltX" label="X轴倾斜"> </af-table-column>
      <af-table-column prop="tiltY" label="Y轴倾斜"> </af-table-column>
      <af-table-column prop="tiltZ" label="Z轴倾斜"> </af-table-column>
      <af-table-column prop="fallHeight" label="自由落体高度">
      </af-table-column>
      <af-table-column prop="gpsSource" label="GPS来源"> </af-table-column>
      <af-table-column prop="cellNum" label="基站个数"> </af-table-column>
      <af-table-column prop="network" label="网络制式"> </af-table-column>
      <af-table-column prop="band" label="工作波段"> </af-table-column>
      <af-table-column prop="bumpy" label="颠簸"> </af-table-column>
      <af-table-column prop="move" label="移动"> </af-table-column>
      <af-table-column prop="impact" label="撞击"> </af-table-column>
      <af-table-column prop="ownerTurn" label="翻倒"> </af-table-column>
      <af-table-column prop="staticVal" label="静止"> </af-table-column>
      <af-table-column prop="bump" label="跌撞"> </af-table-column>
      <af-table-column prop="freeFall" label="自由落体"> </af-table-column>
      <af-table-column prop="powerOn" label="开机告警"> </af-table-column>
      <af-table-column prop="powerOff" label="关机告警"> </af-table-column>
      <af-table-column prop="trip" label="行程状态"> </af-table-column>
      <af-table-column prop="his" label="历史数据补报"> </af-table-column>
      <af-table-column prop="collStatus" label="终端采集状态">
      </af-table-column>
      <af-table-column prop="lowElec" label="低电状态"> </af-table-column>
      <af-table-column prop="flight" label="飞行状态"> </af-table-column>
      <af-table-column prop="report" label="立即上报状态"> </af-table-column>
      <af-table-column prop="reportType" label="上报采集数据标志">
      </af-table-column>
      <af-table-column prop="inLowElecEvent" label="进入低电">
      </af-table-column>
      <af-table-column prop="exitLowElecEvent" label="退出低电">
      </af-table-column>
      <af-table-column prop="inFlightEvent" label="进入飞行模式">
      </af-table-column>
      <af-table-column prop="exitFlightEvent" label="退出飞行模式">
      </af-table-column>
      <af-table-column prop="dataType" label="数据类型"> </af-table-column>

      <af-table-column prop="cells" label="基站"> </af-table-column>
      <af-table-column prop="velocity" label="总角速度"> </af-table-column>
      <af-table-column prop="xvelocity" label="x角速度"> </af-table-column>
      <af-table-column prop="yvelocity" label="y角速度"> </af-table-column>
      <af-table-column prop="zvelocity" label="z角速度"> </af-table-column>
      <af-table-column prop="tempFault" label="温度传感器故障">
      </af-table-column>
      <af-table-column prop="humFault" label="湿度传感器故障">
      </af-table-column>
      <af-table-column prop="positivePhotoFault" label="正面传感器故障">
      </af-table-column>
      <af-table-column prop="reversePhotoFault" label="反面传感器故障">
      </af-table-column>
      <af-table-column prop="speedFault" label="加速度传感器故障">
      </af-table-column>
      <af-table-column prop="anagularVelocityFault" label="角速度传感器故障">
      </af-table-column>
      <af-table-column prop="angleFault" label="倾角传感器"> </af-table-column>
      <af-table-column prop="gpsFault" label="GPS功能"> </af-table-column>
      <af-table-column prop="ip" label="ip地址"> </af-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  data() {
    return {
      data: [],
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      id: 0,
      startTime: "",
      endTime: "",
      tableHeight: "550px",
    };
  },
  async created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
      this.tableHeight = document.documentElement.clientHeight - 200 + "px";
    } else {
      this.$router.go(-1);
    }
  },
  filters: {
    yorn: (value) => {
      switch (value) {
        case "0":
          return "正常";
        case "1":
          return "故障";
        default:
          return "";
      }
    },
  },
  methods: {
    renderheader(h, { column }) {
      return h("span", {}, [
        h("span", {}, column.label.split("/")[0]),
        h("br"),
        h("span", {}, column.label.split("/")[1]),
        h("br"),
        h("span", {}, column.label.split("/")[2]),
        h("br"),
        h("span", {}, column.label.split("/")[3]),
      ]);
    },
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      let params = {
        id: this.id,
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.startTime != "") {
        params.startTime = this.startTime;
      }
      if (this.endTime != "") {
        params.endTime = this.endTime;
      }
      this.$http.post("/manage/dev/his", params).then((results) => {
        this.data = results["data"]["data"]["records"];
        this.pagin.total = results["data"]["data"]["total"];
      });
    },
    block() {
      this.$router.push("/setting/admin");
    },
  },
  components: { Pagination },
};
</script>
